import React from 'react';
import TagEditNavbar from '../TagEditNavbar';
import TagEditInfo from '../TagEditInfo';
import TagEditTagTabMain from '../TagEditTagTabMain';
import './TagEditWrap.scss';

const TagEditWrap = (props) => {
  const {
    form,
    tagEdit,
    tagGroupSelectList,
    onSubmit,
    setData,
    onChangeTagName,
    getTagSearchList,
    selectRecommendTag,
    getRecommendTagList,
    selectTagTrendMainItemList,
    onDragEndSelectTagTrendMainItemList,
    tagPreview,
    permitRegistrationTag,
    rejectRegistrationTag,
  } = props;
  const { tagInfo, tagTabMain, tagSearchSelectList, recommendTagSelectList } = tagEdit;

  return (
    <div className="tag-edit-wrap">
      {/* 하단 네브바 */}
      <TagEditNavbar
        onSubmit={onSubmit}
        status={tagInfo.status}
        tagPreview={tagPreview}
        permitRegistrationTag={permitRegistrationTag}
        rejectRegistrationTag={rejectRegistrationTag}
      />

      {/* 태그 정보 */}
      <TagEditInfo
        form={form}
        tagInfo={tagInfo}
        tagSearchSelectList={tagSearchSelectList}
        tagGroupSelectList={tagGroupSelectList}
        recommendTagSelectList={recommendTagSelectList}
        setData={setData}
        onChangeTagName={onChangeTagName}
        getTagSearchList={getTagSearchList}
        selectRecommendTag={selectRecommendTag}
        getRecommendTagList={getRecommendTagList}
      />

      {/* 태그의 대표 컨텐츠 아이템*/}
      {tagInfo.tagId ? (
        <TagEditTagTabMain
          tagTabMain={tagTabMain}
          selectTagTrendMainItemList={selectTagTrendMainItemList}
          onDragEndSelectTagTrendMainItemList={onDragEndSelectTagTrendMainItemList}
        />
      ) : null}
    </div>
  );
};

export default TagEditWrap;
